// only for doctor
import { FontAwesome } from "@expo/vector-icons";
import React, { useEffect, useState } from "react";
import { Text, TouchableOpacity, View } from "react-native";
import { StepHeader } from "../../../components/all";
import colors from "../../../constants/colors";
import Styles from "../../../constants/styles";
import professions from "../../../constants/lov/professions";
import { useSelector } from "react-redux";

export default function Step5({ navigation, setField, setFields }) {
  const input = {
    emailCode: "emailCode",
    isGP: "isGP",
    isSpecialist: "isSpecialist",
    expertise: "expertise",
  };

  const [selectedExpertise, setSelectedExpertise] = React.useState(null);
  const [profession, setProfession] = useState("");
  const { fields } = useSelector((state) => state.register);


  useEffect(() => {
    getProfession();
  }, [])

  const getProfession = () => {
    const v = professions.find((prof) => prof.id === fields?.expertise);
    setProfession(v);
  };


  return (
    <View
      style={{
        ...Styles.webSmallContainer,
        marginTop: 20,
      }}
    >
      <StepHeader
        label={`Medical Expertise`}
        icon={<FontAwesome name="envelope-o" size={24} color="black" />}
        subtitle={`Select your professional field`}
      />
      <View style={{ alignItems: "center", margin: 18, marginTop: 32 }}>
        {profession?.types?.map((type, index) => {
          let p = professions.find(prof => prof.id === type)
          return (
            <TouchableOpacity
              onPress={() => {
                let f = {
                  isSpecialist: p?.isSpecialist,
                }
                // setField(input.isSpecialist, p?.isSpecialist);
                if(p.id >= 200) f.expertise = p.id;
                setFields(f);
                setSelectedExpertise(index + 1);
              }}
            >
              <View
                style={{
                  ...styles.category,
                  borderColor:
                    selectedExpertise === index + 1
                      ? colors.primary
                      : "transparent",
                  backgroundColor:
                    selectedExpertise === index + 1
                      ? "white"
                      : "rgba(0,0,0,0.04)",
                }}
              >
                <Text>{p.name}</Text>
              </View>
            </TouchableOpacity>
          )

        })}
      </View>
    </View>
  );
}

const styles = {
  category: {
    padding: 12,
    margin: 6,
    marginTop: 10,
    paddingHorizontal: 24,
    alignItems: "center",
    borderWidth: 1,
    borderRadius: 10,
    minWidth: "80%",
  },
};
